import React, { useState } from "react";
import CommunityComment from "./CommunityComment";

const CommunityCardDetails = ({
  commentCount,
  state,
  city,
  categoryName,
  id,
  setSelectedCommunity,
  selectedCommunity,
  handleShowLoginModal,
  updateCommentCount
}) => {
  return (
    <>
      <div className="d-flex align-items-start mt-4 pera ">
        <button className="btn ms-0 me-4">{categoryName}</button>
        <button className="btn ms-2 ">
          {city}, {state}
        </button>
        <CommunityComment
        updateCommentCount={updateCommentCount}
          commentCount={commentCount}
          id={id}
          setSelectedCommunity={setSelectedCommunity}
          handleShowLogin={handleShowLoginModal}
          selectedCommunity={selectedCommunity}
        />
      </div>
    </>
  );
};

export default CommunityCardDetails;
